import { z } from "zod"
import { type Scalar } from "@/graphql"

export type Schedule = Scalar<"ScheduleType">

export const Schedule = {
    BACS_TRANSFER: "BACS_TRANSFER",
    CARD_PAYMENT: "CARD_PAYMENT",
    DIRECT_DEBIT: "DIRECT_DEBIT",
    PAYMENT_SLIP: "PAYMENT_SLIP",
} as const satisfies Record<Schedule, Schedule>

export const ScheduleSchema = z.enum(Schedule)
